import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, useHistory } from "react-router-dom";
import { Provider } from "react-redux";
import configureStore from "./Store/configureStore";
import iniciarConfiguracionAPI from "./Services/configAwsInit";
import { PersistGate } from "redux-persist/integration/react";
import Routers from "./Containers/routers";
import Header from "./Components/header";
import { route } from "./Utils/constants.js";
import useSessionCognito from "./customHook/useSessionCognito";
import ModalExpiredSession from "./Components/modalExpiredSession";
import Layout from "./Components/Layout.jsx";
// import { useIdleTimer } from "react-idle-timer";
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

const { persistor, store } = configureStore();

const App = () => {
  let elrouter = useHistory();
  const [active, seActive] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  const sessionNotValid = useSessionCognito();
  const onIdle = () => {
    setSessionExpired(true);
  };
  // const idleTimer = useIdleTimer({ onIdle, timeout: 60 * 60 * 1000 });
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("sesion")) {
      localStorage.setItem("sesion", params.get("sesion"));
    }
    iniciarConfiguracionAPI();
    if (sessionNotValid) {
      setSessionExpired(true);
    } else {
      setSessionExpired(false);
    }
  }, [sessionNotValid]);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router basename={route.BASENAME}>
          <Layout>
            <Header
              openPanel={() => seActive(true)}
              closePanel={() => seActive(false)}
              active={active}
            />
            <ModalExpiredSession open={sessionExpired} />
            <Routers active={active} closePanel={() => seActive(false)} />
          </Layout>
        </Router>
      </PersistGate>
    </Provider>
  );
};
export default App;
